import { EventBus } from '@vtblife/event-bus';
export function sendNotification(data) {
  var event = {
    type: 'app:notification',
    data: data,
    category: 'simple'
  };
  EventBus.getInstance().publish(event);
}